'use client';

import { SvgVisible } from '@common/icon';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { isBot } from '@/utils/isBot';

interface ViewCountProps {
  id: number;
}

export const ViewCount = ({ id }: ViewCountProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const { data } = useQuery({
    ...(isLogin
      ? AuthQueryOptions['get:/wello/v2/auth/policy/feedback/{policyId}']
      : UnauthQueryOptions['get:/wello/v2/allows/policy/feedback/{policyId}'])({
      path: {
        policyId: id,
      },
    }),
    enabled: isLogin !== undefined && !isBot(),
    placeholderData: keepPreviousData,
    select: ({ context }) => ({
      readingCount: context?.readingCount,
      hasNewComment: context?.newCommentYN ?? false,
      isThumbUp: context?.likeYN ?? false,
      thumbUpCount: context?.likeCount ?? 0,
      isBookmarked: context?.wishlistYN,
      bookmarkCount: context?.wishlistCount ?? 0,
      commentCount: context?.commentCount ?? 0,
      likeCount: context?.likeCount ?? 0,
    }),
  });

  const readingCount = data?.readingCount;

  return (
    <small className="flex items-center gap-2 py-2 font-600 text-Gray-550 typo-caption1">
      <SvgVisible className="size-12" />
      {typeof readingCount === 'number'
        ? readingCount.toLocaleString('ko-KR')
        : '-'}
      명이 보는 중
    </small>
  );
};
